import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../../apiClient'

type ErrorClassificationRequest = {
  programId?: string
  start_date?: string
  end_date?: string
  filter_by: 'aggregate_resolution' | 'task_resolution'
  scope?: 'live'
}

type ErrorClassificationType = 'object_detection' | 'classification' | 'response'

type ClassificationError = {
  response: {
    wrong: string
    correct: string
    type: ErrorClassificationType
    subType?: string
  }
  count: number
  countTrend?: number
  share: number
  shareTrend?: number
  population: {
    percentage: number
    members: { name: string; operatorId: string; imageUrl?: string }[]
  }
  autonomousSystems: number
  key: string
}

type ErrorClassificationResponse = {
  total: number
  errors: ClassificationError[]
}

export const PROGRAM_QUALITY_METRICS_COMMON_MISTAKES = 'program-quality-metrics-common-mistakes'

export function useGetCommonMistakes(params: ErrorClassificationRequest) {
  return useQuery({
    queryKey: [PROGRAM_QUALITY_METRICS_COMMON_MISTAKES, params],
    queryFn: async () =>
      (
        await apiClient.get(`/int/v3/programs/${params.programId}/metrics/common-mistakes`, {
          params: {
            startDate: params.start_date,
            endDate: params.end_date,
            filterBy: params.filter_by,
            ...(params.scope ? { scope: params.scope } : {}),
          },
        })
      ).data,
    select: (data) => {
      const response = {
        total: data?.length ?? 0,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        errors: data.map((error: any, idx: number) => ({ ...error, key: idx })),
      } as ErrorClassificationResponse

      return response
    },
    enabled: Boolean(params?.programId) && Boolean(params?.start_date) && Boolean(params?.end_date),
    refetchOnWindowFocus: false,
  })
}
